export const getReportCommissionPage = () => ({
  type: 'route',
  path: 'reports/commissions',
  routes: [
    {
      type: 'application',
      name: '@crm/dashboard/report',
      loader: System.import('@crm/skeletor'),
    },
  ],
});
